import React from "react";

import { useFormatTimestamp } from "./timeFormat";

/**
 * Formatted text of a wall-clock ns instant, as a bare fragment, so
 * {@link Timestamp} and anything else showing an instant track the user's
 * format, precision, and t=0 anchor. Outside a TimestampFormatProvider it renders with the default
 * format and options rather than throwing.
 */
export const FormattedTimestampText: React.FC<{ ns: bigint }> = ({ ns }) => {
  const formatTimestampNs = useFormatTimestamp();
  return <>{formatTimestampNs(ns)}</>;
};
